export const serviceCycleText = value => ({ 1: '月度服务', 2: '季度服务', 3: '暂不服务' }[value] || '-')

export const portraitConclusionText = value => {
  if (value === true || value === 1) return '符合3.0及以上画像'
  if (value === false || value === 0) return '不符合3.0及以上画像'
  return '未标记画像'
}
